import { type Dictionary } from '@ngrx/entity';

import {
  type CanvasElement,
  type CanvasElementId,
  type CanvasElementPathNode,
  type CanvasNamespaceId,
  type LayoutData,
} from '@blaze-runtime/engine-domain';
export interface ElementsState {
  entities: Dictionary<CanvasElement>;
  ids: string[] | number[];
  layoutEntities?: Record<CanvasNamespaceId, LayoutData>;
  layoutIds?: CanvasNamespaceId[];
  offSyncLayouts?: Record<CanvasNamespaceId, boolean>;
  /** Runtime-added overlays */
  overlays?: CanvasElementId[];
  selectedPathNode?: CanvasElementPathNode;
}

export const initialElementsState: ElementsState = {
  entities: {},
  ids: [],
  layoutEntities: {},
  layoutIds: [],
  offSyncLayouts: {},
  overlays: [],
  selectedPathNode: undefined,
};
